export const DEFAULT_BOX_SIZE = 24;
